import axios from 'axios';
import toastr from 'toastr';
import Cookie from 'cookies-js';
import config from '../../config/index';
import routes from '../../constants/routes';
import {
  DELETE_BANK_DETAILS
} from '../types';

const deleteBankDetails = bankId => ({
  type: DELETE_BANK_DETAILS,
  bankId
});

const deleteUserBankDetails = bankDetails => (dispatch) => {
  const token = Cookie.get('jwtToken');
  console.log('==>: ', bankDetails);
  axios.delete(`${config.apiUrl}${routes.DELETEUSERBANK}`, { data: bankDetails }, {
    headers: { Authorization: `Bearer ${token}` }
  }).then((response) => {
    const {
      isSuccessful
    } = response.data;
    if (isSuccessful) {
      console.log(response.data);
      dispatch(deleteBankDetails(bankDetails.accountId));
      toastr.success('Bank details successfully deleted');
    }
  }).catch((error) => {
    throw error;
  });
};

export default deleteUserBankDetails;
